import React, { useState } from 'react';
import { Bars } from 'react-loader-spinner';
import PropTypes from 'prop-types';
import {
	NotificationContainer,
	NotificationManager,
} from 'react-notifications';
import { Modal } from '../../../../layouts';
import { StyledRowFile } from '../ActivityFile/index.styled';
import { getDocumentContent } from '../../utils/activity';
import Popup from '../../../../layouts/Popup';
import fileIcon from '../../../../assets/images/logos/fileIcon.png';
import { StyledBlockModal } from '../../../planning/components/Calendar/index.styled';

const ActivityFileItem = ({ file, data, setData }) => {
	const [isLoading, setIsLoading] = useState(false);
	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;

	const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (
			let offset = 0;
			offset < byteCharacters.length;
			offset += sliceSize
		) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i += 1) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};

	const handlePreview = (document) => {
		const url = `data:${document.mimeType};base64,${document.content}`;
		const extensionPart = document.fileName.split('.');

		let fileURL = '';
		if (document.content) {
			const blob = new Blob([b64toBlob(document.content)], {
				type: document.mimeType,
			});

			fileURL = URL.createObjectURL(blob);
		}

		setData({
			...data,
			downloadableDocument: true,
			url,
			name: document.fileName,
			mimeType: document.mimeType,
			extension: extensionPart[extensionPart.length - 1],
			document,
			fileUrl: fileURL,
		});
	};
	const togglePopup = () => {
		setData({
			...data,
			downloadableDocument: false,
		});
	};

	const downloadFile = (response) => {
		const blob = b64toBlob(response.content, response.mimeType);
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.download = response.fileName; // Set the filename for the download
		link.href = url;
		// Append the link to the document (necessary for Firefox)
		document.body.appendChild(link);
		link.click();
		URL.revokeObjectURL(url);
		link.remove();
	};

	const handleFileClick = async (token) => {
		let response = '';
		setIsLoading(true);
		if (!data.document || data.document.token !== token) {
			response = await getDocumentContent(token);
		} else {
			response = data.document;
		}

		if (response) {
			setIsLoading(false);
			if (isVersionPC()) {
				handlePreview(response);
			} else {
				downloadFile(response);
			}
		} else {
			setIsLoading(false);
			NotificationManager.error(
				"Une erreur s'est produite lors de la récupération du document",
				'',
			);
		}
	};

	let widtModal = '90%';
	if (isVersionPC()) {
		widtModal = '40%';
	}

	return (
		<>
			<StyledRowFile>
				<img src={fileIcon} width="40" />
				<a
					onClick={() => {
						handleFileClick(file.token);
					}}
				>
					{file.type}
				</a>
			</StyledRowFile>
			<NotificationContainer />
			{data.downloadableDocument && data.extension === 'pdf' && (
				<Popup
					handleClose={togglePopup}
					content={
						<object
							type={data.mimeType}
							data={data.fileUrl}
							width={1000}
							height={1500}
						></object>
					}
				></Popup>
			)}
			{data.downloadableDocument && data.extension !== 'pdf' && (
				<Popup
					handleClose={togglePopup}
					content={<img src={data.fileUrl} />}
				></Popup>
			)}
			{isLoading ? (
				<Modal
					onClickCallback=""
					title=" "
					cancelAction=""
					confirmAction=""
					style={{
						position: 'fixed',
						width: widtModal,
					}}
				>
					<StyledBlockModal>
						<Bars
							height="80"
							width="80"
							color="#b8cbf2"
							ariaLabel="bars-loading"
							wrapperStyle={{}}
							wrapperClass=""
							visible={true}
						/>
					</StyledBlockModal>
				</Modal>
			) : null}
		</>
	);
};

ActivityFileItem.propTypes = {
	file: PropTypes.object,
	data: PropTypes.object,
	setData: PropTypes.func,
};

export default ActivityFileItem;
